import {
    ButtonGroup,
    ModalHeader,
    ModalBody,
    ModalFooter,
    VStack,
    useToast,
    Input,
    Button,
    InlineBanner,
    FormControl,
    Box,
} from '@cad-arc';
import { FC, useState } from 'react';
import { useBootstrapState } from '../../bootstrap/bootstrap-provider';
import { UseMaLeapsPasswordReturn } from '../use-dex-password-api';

type MaLeapsPasswordModalProps = {
    onClose: () => void;
    leapsPasswordInfo: UseMaLeapsPasswordReturn;
};

export const MaLeapsPasswordModal: FC<MaLeapsPasswordModalProps> = ({
    onClose,
    leapsPasswordInfo,
}) => {
    const { userProfileView: userProfile } = useBootstrapState();

    const [password, setPendingPassword] = useState('');

    const dexCertExipration = `DEx Certification Expiration Date: ${
        userProfile?.dateDexCertificationExpires || 'unknown'
    }`;
    const {
        setPassword,
        errorSettingPassword,
        isSettingPassword,
        doesHavePassword,
    } = leapsPasswordInfo;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPendingPassword(event.target.value);
    };

    const toast = useToast();

    const handleSave = () => {
        if (password.length) {
            setPassword(password).then((success) => {
                if (success) {
                    onClose();
                    toast({
                        status: 'default',
                        description: 'Successfully set LEAPS password',
                    });
                }
            });
        }
    };

    return (
        <>
            <ModalHeader>Set MA LEAPS Password</ModalHeader>

            <ModalBody>
                <VStack spacing={6}>
                    {errorSettingPassword && (
                        <Box w="full">
                            <InlineBanner
                                status="error"
                                title="Error when setting password"
                                description="Please try again."
                            />
                        </Box>
                    )}
                    {doesHavePassword && (
                        <Box w="full">
                            <InlineBanner
                                status="info"
                                description="Your user has an existing MA LEAPS password."
                            />
                        </Box>
                    )}
                    <FormControl label="DEx State User ID" helpText={dexCertExipration}>
                        <Input width="100%" value={userProfile?.dexStateUserId} readOnly />
                    </FormControl>

                    <FormControl
                        label={doesHavePassword ? 'Update Password' : 'Enter Password'}
                        htmlFor="Enter Password"
                        errorMessage="Password must not be empty"
                        isInvalid={password.length === 0}
                    >
                        <Input
                            data-testid="dex-password-input"
                            name="Enter Password"
                            aria-labelledby="Enter Password"
                            onChange={handleChange}
                            type="password"
                            width="100%"
                            value={password}
                        />
                    </FormControl>
                </VStack>
            </ModalBody>

            <ModalFooter>
                <ButtonGroup>
                    <Button disabled={isSettingPassword} onClick={onClose} variant="ghost">
                        Cancel
                    </Button>
                    <Button
                        disabled={!password.length}
                        isLoading={isSettingPassword}
                        onClick={handleSave}
                        variant="solid"
                    >
                        Save Password
                    </Button>
                </ButtonGroup>
            </ModalFooter>
        </>
    );
};
